<template>
    <div>
         <a-button @click="showModal">
                                        <a-icon type="upload" />  مهمانان
                                    </a-button>

        <a-modal width="1000px" v-model="visible" title=" مهمانان سمینار" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>
            <form @submit.prevent="addData($event)">

            <div class="row text-right">
             
                <div class="col-md-12">
                    <div class="form-group text-right">
                    <a-button target="_blank" href="https://asan-tahator.com/importGuest.xlsx">
                                        <a-icon type="upload" />  مشاهده نمونه
                                    </a-button>
                                    &nbsp;
                        <label for="">  آپلود فایل اکسل</label>

                        <input id="file" name="file" type="file" class="form-control">
                    </div>
                </div>

               
                <input name="sans_id" type="hidden" :value="$route.params.id">

                <div class="mt-1">
                    <button type="submit" class="btn btn-fill btn-outline-success ">
                            ذخیره
                        </button>
                </div>
            </div>
            </form>
         
        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            seminar: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
            };
        },
        methods: {
            addData(event) {
                 let _this = this;
                let formData = new FormData();
                formData.append("file", document.getElementById('file').files[0]);
                formData.append("seminar_id",this.seminar.id);
                axios.post("/seminars/guests/importSeminar", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(function(response) {
                        _this.$toast.success("فایل اکسل با موفقیت ذخیره شد.   ");

                    })
                    .catch(function(err) {
                        _this.$toast.error("فایل ارسالی  صحیح  نیست.   ");
                        _this.$root.handleAxiosError(err);
                    });
            },
         
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')

            },
        },
    };
</script>
